import React, { ReactNode } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icons
} from '@clientbase/clientbase-library'

import { cardTittle } from 'components/Modal/ModalChargeDetail/ModalChargeDetail.utils'

import { theme } from 'styles/theme'

interface AccordionProps {
  icon: Icons
  text: string
  children: ReactNode
  defaultExpanded?: boolean
}
const ExpensesAccordion = ({
  icon,
  text,
  children,
  defaultExpanded = true
}: AccordionProps) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          margin: 0,
          backgroundColor: '#fff'
        }
      }}
    >
      <AccordionSummary aria-controls="payerDetails-content" id="payerDetails">
        {cardTittle(text, icon, `${theme.palette.primary[700]}`)}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}

export default ExpensesAccordion
